import { useEffect } from 'react';
import { Context } from '@/api/spec.ts';
import useStore from '../rootStore.ts';

export function useAppConfigWatcher() {
  const config = useStore((state) => state.config);
  const configStatus = useStore((state) => state.configStatus);

  useEffect(() => {
    if (config) {
      return;
    }

    if (typeof ResourceLoader === 'undefined') {
      console.error('ResourceLoader is not available — config preloading script may have been blocked');
      return;
    }

    const configResource = ResourceLoader.getResource('config');
    if (configResource?.status === 'success' && configResource.handle) {
      useStore.getState().setConfig(configResource.handle as Context);
      return;
    }

    return useStore.getState().subscribeToConfigChanges();
  }, [config, configStatus]);
}
